


































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import { Question, newQuestion } from "@/api/minutes-api";
import VDelete from "@/components/VDelete.vue";
import VPrompt from "../components/VPrompt.vue";
import MinuteTypeList from "@/templates/MinuteTypeList.vue";
import VToolbar from "@/ui/common/components/VToolbar.vue";

import MinuteTypeService from "@/services/minute-type-service";

import SwitchButton from "@/components/SwitchButton.vue";

const service = new MinuteTypeService();

@Component({
  components: {
    VToolbar,
    MinuteTypeList,
    VPrompt,
    VDelete,
    SwitchButton
  }
})
export default class MinuteTypeEditPage extends Vue {
  @Prop({ required: true }) questionId!: string;

  question: Question = newQuestion();
  validated = false;

  /**
   * 項目を2つ以上持っているかどうか
   */
  get hasManyAnswers(): boolean {
    return this.question.answers.length > 1;
  }

  /**
   * 一覧に戻る
   */
  goListPage() {
    this.$router.push({ name: "minute-type" });
  }

  status = "";

  async save(): Promise<void> {
    this.status = "progressing";
    await service.save(this.question);
    this.goListPage();
  }

  async remove(): Promise<void> {
    if (!confirm("本当に削除してもよろしいですか？")) return;
    await service.destroy(this.questionId);
    this.goListPage();
  }

  removeAnswer(answerIndex: number): void {
    service.removeAnswerFrom(this.question, answerIndex);
  }

  appendAnswerOptionTo(answer: any): void {
    service.appendAnswerOptionTo(answer);
  }

  removeAnswerOptionFrom(answer: any, optionIndex: number): void {
    service.removeAnswerOptionFrom(answer, optionIndex);
  }

  appendAnswer() {
    service.appendAnswerTo(this.question);
  }

  changeAnswerType(answer: any) {
    service.changeAnswerType(answer);
  }

  protected async created() {
    this.question = await service.edit(
      this.questionId,
      this.$store.state.projectId
    );
  }
}
